// ------------------------------------
// Constants
// ------------------------------------
// prettier-ignore
export const ADDRESSES_POST_REQUEST = 'ADDRESSES_POST_REQUEST';
// prettier-ignore
export const ADDRESSES_POST_REQUEST_SUCCESS = 'ADDRESSES_POST_REQUEST_SUCCESS';
// prettier-ignore
export const ADDRESSES_POST_REQUEST_FAILURE = 'ADDRESSES_POST_REQUEST_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------
export function request(payload, resolve, reject) {
  return {
    type: ADDRESSES_POST_REQUEST,
    payload,
    resolve,
    reject,
  };
}

export function requestSuccess(data) {
  return {
    type: ADDRESSES_POST_REQUEST_SUCCESS,
    data,
  };
}

export function requestFailure(error) {
  return {
    type: ADDRESSES_POST_REQUEST_FAILURE,
    error,
  };
}
